import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function TermsPrivacyPage() {
      return (
    <div>
      <Header/>
      <main className='wrapper top-space bottom-space'>
        <h1 className='text-title2 lg:text-display1 text-center'>개인정보 처리 방침</h1>
        
        <div className='mt-[120px]'>
          <ol className='text-heading3 [&>li]:mt-[5px]'>
            <li>개인정보 처리 방침</li>
            <li>개인정보 수집</li>
            <li>개인정보 이용</li>
            <li>개인정보 제공</li>
            <li>개인정보 파기</li>
            <li>기타 사항</li>
          </ol>

          <hr className='my-[60px]' />   

          <div className='space-y-[80px]'>
            <div>
              <h2 className='text-heading3'>1. 개인정보 처리 방침이란?</h2>
              <div className='mt-[30px]'>
                  주식회사 모듈링크(이하 "회사")는 이용자의 ‘동의를 기반으로 개인정보를 수집·이용 및 제공’하고 있으며, ‘이용자의 권리(개인정보 자기 결정권)를 적극적으로 보장’합니다.
                  <br/><br/>
                  회사는 정보통신 서비스 제공자가 준수하여야 하는 대한민국의 관계 법령 및 개인정보보호 규정, 가이드라인을 준수하고 있습니다.
                  <br/><br/>          
                  “개인정보 처리 방침”이란 이용자의 소중한 개인정보를 보호함으로써 이용자가 안심하고 서비스를 이용할 수 있도록 회사가 준수해야 할 지침을 의미합니다. 
                  <br/><br/>          
                  본 개인정보 처리 방침은 회사가 제공하는 모듈링크 계정 기반의 서비스(이하 ‘서비스'라 함)에 적용됩니다.
                </div>
            </div>

            <div>
                <h2 className='text-heading3'>2. 개인정보 수집</h2>
                <div className='mt-[30px]'>
                    <span className='font-semibold'>서비스 제공을 위한 필요 최소한의 개인정보를 수집하고 있습니다.</span>
                    <br/><br/>
        
                    회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별 애플리케이션이나 프로그램 등을 통해 아래와 같은 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하고 있습니다.<br/>

                    <br/>
                    <div>
                        <h3 className='text-body1'>[모듈링크 계정]</h3>
                        <ul>
                          <li>
                            필수 : SNS 아이디, 이메일 주소, 회원 가입일, 제품 고유번호, 위치정보 데이터
                          </li>
                          <li>
                            선택 : 혈액형, 응급구조 시 참고사항, 가입 보험사 정보
                          </li>
                        </ul>
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>[본인인증 후 서비스 이용 시]</h3>
                        <ul>
                          <li>필수 : 이름, 성별, 생년월일, 휴대전화 번호, 통신사업자, 내/외국인 여부, 암호화된 이용자 확인 값(CI), 중복가입 확인 정보(DI), 서비스 이용 내역, 서비스 내 구매 및 결제 내역, 휴대전화 위치정보, 긴급상황 호출 위치정보</li>
                        </ul>
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>[법정대리인 동의 후 서비스 이용 시]</h3>
                        <ul>
                          <li>필수 : 이름, 성별, 생년월일, 휴대전화 번호, 통신사업자, 내/외국인 여부, 암호화된 이용자 확인 값(CI), 중복가입 확인 정보(DI), 서비스 이용 내역, 서비스 내 구매 및 결제 내역, 휴대전화 위치정보, 긴급상황 호출 위치정보</li>
                        </ul>
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>[유료 서비스 이용 시]</h3>
                        <ul>
                          <li>신용카드 결제 시 : 카드번호(일부), 카드사명 등</li>
                          <li>휴대전화 번호 결제 시 : 휴대전화 번호, 결제 승인 번호 등</li>
                        </ul>
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>[환불 처리 시]</h3>
                        계좌은행, 계좌번호, 예금주명, 이메일
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>[현금영수증 발행 시]</h3>
                        휴대전화 번호, 현금영수증 카드번호<br/>
                        <br/>
                        일부 서비스에서는 특화된 여러 기능을 제공하기 위해 ‘모듈링크 계정’에서 공통으로 수집하는 정보 이외에 이용자에게 동의를 받고 추가적인 개인정보를 수집할 수 있습니다.<br/>
                        <br/>
                        <ul>
                          <li>필수정보란 : 해당 서비스의 본질적 기능을 수행하기 위한 정보</li>
                          <li>선택정보란 : 보다 특화된 서비스를 제공하기 위해 추가 수집하는 정보 (선택 정보를 입력하지 않은 경우에도 서비스 이용 제한은 없습니다.)</li>
                        </ul>
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>개인 정보를 수집하는 방법은 다음과 같습니다.</h3>
                        개인 정보를 수집하는 경우에는 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구하고 있으며, 아래와 같은 방법을 통해 개인정보를 수집합니다.<br/> 
                        <ul>
                          <li>회원 가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의하고 직접 정보를 입력하는 경우</li>
                          <li>제휴 서비스 또는 단체 등으로부터 개인정보를 제공받은 경우</li>
                          <li>고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등을 통해 고객에게 제공받은 경우</li>
                          <li>온·오프라인에서 진행되는 이벤트/행사 등 참여</li>
                        </ul>
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>서비스 이용 과정에서 이용자로부터 수집하는 개인정보는 아래와 같습니다.</h3>
                        PC 웹, 모바일 웹/앱 이용 과정에서 단말기 정보(OS, 화면 사이즈, 디바이스 아이디, 핸드폰 기종, 단말기 모델명), IP
                        주소, 쿠키, 방문일시, 부정 이용기록, 서비스 이용기록 등의 정보가 자동으로 생성되어 수집될 수 있습니다.
                    </div>
                    <br/>
                    <div>
                        <h3 className='text-body1'>서비스 간 제휴, 연계 등으로 제3자로부터 개인정보를 제공받고 있습니다.</h3>
                    </div>
                </div>
            </div>

            <div>
                <h2 className='text-heading3'>3. 개인정보 이용</h2>
                <div className='mt-[30px]'>
                    <div className='font-semibold'>
                        회원 관리, 서비스 제공·개선, 신규 서비스 개발 등을 위해 이용합니다.
                        회원 가입 시 또는 서비스 이용 과정에서 홈페이지 또는 개별 애플리케이션이나 프로그램 등을 통해 아래와 같이 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하고 있습니다. 
                    </div>
                    <br/>

                    <ul>
                      <li>회원 식별/가입 의사 확인, 본인/연령 확인, 부정 이용 방지</li>
                      <li>만 14세 미만 아동 개인정보 수집 시 법정 대리인 동의 여부 확인, 법정 대리인 권리행사 시 본인 확인</li>
                      <li>신규 서비스 개발, 다양한 서비스 제공, 문의 사항 또는 불만 처리, 공지 사항 전달</li>
                      <li>유료 서비스 이용 시 콘텐츠 등의 전송이나 배송·요금 정산</li>
                      <li>서비스의 원활한 운영에 지장을 주는 행위(계정 도용 및 부정 이용 행위 등 포함)에 대한 방지 및 제재</li>
                      <li>인구통계학적 특성과 이용자의 관심, 기호, 성향의 추정을 통한 맞춤형 콘텐츠 추천 및 마케팅에 활용</li>
                      <li>고객의 주행 사고 발생 여부의 식별 및 사고 위험 예측 정확도 향상, 개인화 서비스 제공</li>
                      <li>서비스 이용기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호 측면의 서비스 환경 구축, 서비스 개선에 활용</li>
                      <li>고객의 사고 발생 여부 식별 또는 응급상황 호출 등과 같은 긴급상황 발생 시 원활한 구급차 출동과 응급치료를 위한 각종 신고를 대행하는 서비스에 활용</li>
                    </ul>
                </div>
            </div>

            <div>
                <h2 className='text-heading3'>4. 개인정보 제공</h2>
                <div className='mt-[30px]'>
                    <div className='font-semibold'>
                        당사는 이용자의 별도 동의가 있는 경우나 법령에 규정된 경우를 제외하고는 이용자의 개인정보를 제3자에게 제공하지 않습니다.<br/>
                        <br/>
                        제3자 서비스와의 연결을 위해 아래와 같이 개인정보를 제공하고 있습니다.<br/>
                    </div>
                    당사는 이용자의 사전 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 이용자가 외부 제휴사 등의 서비스를 이용하기 위하여 필요한 범위 내에서 이용자의 동의를 얻은 후에 개인정보를 제3자에게 제공하고 있습니다.<br/>
                    <br/>
                    <span className='font-semibold'>서비스 제공을 위해 아래와 같은 업무를 위탁하고 있습니다.</span><br/>
                    서비스 제공에 있어 필요한 업무 중 일부를 외부 업체로 하여금 수행하도록 개인정보를 위탁하고 있습니다. 그리고 위탁받은 업체가 관계 법령을 준수하도록 관리·감독하고 있습니다.
                </div>
            </div>

            <div>
                <h2 className='text-heading3'>5. 개인정보 파기</h2>
                <div className='mt-[30px]'>
                    <span className='font-semibold'>개인정보는 수집 및 이용 목적이 달성되면 지체 없이 파기하며, 절차 및 방법은 아래와 같습니다.</span><br/>
                    <br/>
                    전자적 파일 형태인 경우 복구 및 재생되지 않도록 안전하게 삭제하고, 그 밖에 기록물, 인쇄물, 서면 등의 경우 분쇄하거나 소각하여 파기합니다.<br/>
                    <br/>
                    다만, 내부 방침에 따라 일정 기간 보관 후 파기하는 정보는 아래와 같습니다.<br/>
                    <br/>
                    
                    <ol>
                      <li>
                        탈퇴일부터 최대 1년간 보관 후 파기하는 정보
                        <ul>
                          <li>안내메일 발송 및 CS 문의 대응을 위해 모듈링크 계정과 탈퇴 안내 이메일 주소</li>
                          <li>서비스 부정 이용기록</li>
                        </ul>
                      </li>
                    </ol>

                    <br/>
                    모듈링크는 ‘개인정보 유효기간제’에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관 또는 삭제하고 있으며, 분리 보관된 개인정보는 4년간 보관 후 지체 없이 파기합니다.<br/>
                    <br/>
                    이 외에 법령에 따라 일정 기간 보관해야 하는 개인정보는 다음과 같습니다.
                    <br/>
                    <br/>
                    <ol>
                      <li>
                        전자상거래 등에서의 소비자 보호에 관한 법률
                        <ul>
                          <li>계약 또는 청약 철회 등에 관한 기록 : 5년</li>
                          <li>대금결제 및 재화 등의 공급에 관한 기록 : 5년</li>
                          <li>소비자의 불만 또는 분쟁 처리에 관한 기록 : 3년</li>
                          <li>표시/광고에 관한 기록 : 6개월</li>
                        </ul>
                      </li>
                      <li>
                          국세기본법
                          <ul>
                            <li>세법이 규정하는 모든 거래에 관한 장부 및 증빙서류 : 5년</li>
                          </ul>
                      </li>
                      <li>
                          전자금융거래법
                          <ul>
                            <li>전자금융 거래에 관한 기록 : 5년</li>
                          </ul>
                      </li>
                      <li>
                          통신비밀보호법
                          <ul>
                            <li>서비스 방문 기록 : 3개월</li>
                          </ul>
                      </li>
                    </ol>
                </div>
            </div>

            <div>
                <h2 className='text-heading3'>6. 기타</h2>
                <div className='mt-[30px]'>
                    <div className='font-semibold'>모듈링크는 여러분의 권리를 보호합니다.</div>
                    <br/>
                    이용자(만 14세 미만인 경우 법정 대리인)는 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며, 수집・이용에 대한 동의 철회 또는 가입 해지를 요청할 수 있습니다.<br/>
                    <br/>
                    보다 구체적으로는 서비스 내 설정을 통한 회원 정보 수정 기능이나 회원 탈퇴 기능을 이용할 수 있고, 고객센터를 통해 서면, 전화 또는 이메일로 요청하시면 지체 없이 조치하겠습니다.<br/>
                    <br/>
                    개인정보의 오류에 대한 정정을 요청하신 경우 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지 않습니다.<br/>
                    <br/>
                    <span className='font-semibold'>웹 기반 서비스의 제공을 위하여 쿠키를 이용하는 경우가 있습니다.</span><br/>
                    <br/>

                    <ul>
                      <li>
                        쿠키
                        <ul className='!list-none'>
                          <li>
                            쿠키는 더욱 빠르고 편리한 웹사이트 사용을 지원하고 맞춤형 서비스를 제공하기 위해 사용됩니다. <br/>
                            웹사이트를 운영하는 데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자 컴퓨터에 저장됩니다. 
                          </li>
                        </ul>
                      </li>
                      <li>
                        사용 목적
                        <ul className='!list-none'>
                          <li>
                            개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 쿠키를 사용합니다.<br/>
                                이용자가 웹사이트에 방문할 경우 웹사이트 서버는 이용자의 디바이스에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하게 됩니다.<br/>
                                쿠키는 이용자가 웹사이트를 방문할 때, 웹사이트 사용을 설정한 대로 접속하고 편리하게 사용할 수 있도록 돕습니다<br/>
                                또한, 이용자의 웹사이트 방문 기록, 이용 형태를 통해서 최적화된 광고 등 맞춤형 정보를 제공하기 위해 활용됩니다. 
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <br/>
                    쿠키 수집 거부<br/>
                    쿠키에는 이름, 전화번호 등 개인을 식별하는 정보를 저장하지 않으며, 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다.
                    따라서, 이용자는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수도 있습니다.
                    다만, 쿠키 설치를 거부할 경우 웹 사용이 불편해지며, 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.<br/>
                    <br/>
                    <div className='font-semibold'>모듈링크는 이용자의 소중한 개인정보 보호를 위해 다음의 노력을 하고 있습니다.</div><br/>
                    이용자의 개인정보를 가장 소중한 가치로 여기고 개인정보를 처리함에 있어서 다음과 같은 노력을 다하고 있습니다.<br/>

                    <ul>
                      <li>해킹이나 컴퓨터 바이러스로부터 보호하기 위하여 노력하고 있습니다.</li>
                      <li>소중한 개인정보에 접근할 수 있는 사람을 최소화하고 있습니다.</li>
                      <li>임직원에게 이용자의 개인정보 보호에 대해 정기적인 교육을 실시하고 있습니다.</li>
                    </ul>
                    <br/>
                    <span className='font-semibold'>[개인정보 처리의 목적 및 처리 근거]</span><br/>
                    <br/>
                    모듈링크는 수집한 개인정보를 "3. 개인정보의 이용"에 기재된 목적으로만 이용하며, 사전에 이용자에게 해당 사실을 알리고 동의를 구하고 있습니다. 
                    그리고 아래 하나에 해당하는 경우에 이용자의 개인정보를 처리할 수 있습니다.<br/>
                    <ul>
                      <li>정보 주체의 동의</li>
                      <li>정보 주체와의 계약의 체결 및 이행을 위한 경우</li>
                      <li>법적 의무 사항 준수를 위한 경우</li>
                      <li>정보 주체의 중대한 이익을 위해 처리가 필요한 경우</li>
                      <li>회사의 적법한 이익 추구를 위한 경우(정보 주체의 이익과 권리 또는 자유가 그 이익보다 중요한 경우는 제외)</li>
                    </ul>
                    <br/>
                    <span className='font-semibold'>개인정보보호와 관련해서 궁금하신 사항은?</span><br/>
                    서비스를 이용하면서 발생하는 모든 개인정보보호 관련 문의, 불만, 조언이나 기타 사항은 아래의 메일주소로 연락해 주시기를 바랍니다. (help@module-link.com)<br/>
                    <br/>
                    또한 개인정보가 침해되어 이에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하셔서 도움을 받으실 수 있습니다.<br/>
                    <br/>
                    개인정보 침해 신고센터<br/>
                    (국번없이) 118<br/>
                    <a href='https://privacy.kisa.or.kr' className='text-blue-600 underline'>https://privacy.kisa.or.kr</a><br/>
                    <br/>
                    대검찰청 사이버수사과<br/>
                    (국번없이) 1301<br/>
                    <a href='https://cybercid.spo.go.kr' className='text-blue-600 underline'>https://cybercid.spo.go.kr</a><br/>
                    <br/>
                    경찰청 사이버안전국<br/>
                    (국번없이) 182<br/>
                    <a href='https://cyberbureau.police.go.kr' className='text-blue-600 underline'>https://cyberbureau.police.go.kr</a><br/>
                    <br/>
                    <span className='font-semibold'>개인정보 처리 방침이 변경되는 경우</span><br/>
                    법률이나 서비스의 변경 사항을 반영하기 위한 목적 등으로 개인정보 처리 방침을 수정할 수 있습니다.
                    개인정보 처리 방침이 변경되는 경우 당사는 변경 사항을 게시하며, 변경된 개인정보 처리 방침은 게시한 날로부터 7일 후부터 효력이 발생합니다.<br/>
                    다만, 수집하는 개인정보의 항목, 이용 목적의 변경 등과 같이 이용자 권리의 중대한 변경이 발생할 때는 최소 30일 전에 미리 알려드리겠습니다.<br/>
                    <br/>
                    주식회사 모듈링크는 이용자 여러분의 정보를 소중히 생각하며, 이용자가 더욱 안심하고 서비스를 이용할 수 있도록
                    최선의 노력을 다할 것을 약속드립니다.
                </div>
            </div>
          </div>
        </div>
      </main>
      <Footer/>
    </div>
  )
}